import BaseComponents from '@components/global-install.js'
import { install as PortalVuePlugin } from 'portal-vue'

export function useComponents (app) {
  app.use(BaseComponents)
  app.use(PortalVuePlugin)
}